import React, { useState, useImperativeHandle } from 'react';

import { InScreenModal, NavBar } from '../../components';

import ServiceAgreementModal from '../../components/component_service_agreement';
import { STATE_KEYS, useGlobalState } from '../../configs/config_state';

const SubscriptionAgreementModal = React.forwardRef((props, ref) => {
    // region Global State
    const [globalTruckData] = useGlobalState(STATE_KEYS.TRUCK_DATA);
    // endregion

    // region Local State
    const [visible, setVisible] = useState(false);
    // endregion

    // region Expose Methods
    useImperativeHandle(ref, () => ({ showModal: () => setVisible(true), hideModal: () => setVisible(false) }), []);
    // endregion

    // region MAIN RENDER
    return(
        <InScreenModal visible={visible}>
            {/* Nav Bar */}
            <NavBar
                title={'Subscription Agreement'}
                hideBorder={false}
                leftButtonOnPress={() => setVisible(false)}
            />

            {/* Content */}
            <ServiceAgreementModal
                style={{ paddingHorizontal: 0 }}
                useView={true}
                truckName={globalTruckData.name}
                readOnly={true}
                onAccept={() => setVisible(false)}
            />
        </InScreenModal>
    );
    // endregion
});

export default SubscriptionAgreementModal;
